import * as moment from 'moment';
import { FormEvent, useState } from 'react';
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Modal } from 'react-bootstrap';
import { FileRejection, DropEvent } from 'react-dropzone';
import FileUpload from '@nkr/components/file-upload';

interface IProps {
    show: boolean,
    fullName: string,
    onSubmit: (file: File, expirationDate: string) => void,
    onCancel: () => void
}

const UploadScrip = (props: IProps) => {
    const [files, setFiles] = useState<File[]>([]);
    const [filesValid, setFilesValid] = useState(true);
    const [expirationDate, setExpirationDate] = useState('');
    const [expirationDateValid, setExpirationDateValid] = useState(true);
    const [dirty, setDirty] = useState(false);

    const handleFileDropped = (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => {
        setFiles(acceptedFiles);
    };

    const handleRemoveFile = (name: string) => {
        setFiles([]);
    };

    const handleExpirationDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        setExpirationDate(e.currentTarget.value);
    };

    const handleSubmit = () => {
        let filesValid = files.length > 0;
        let expirationDateValid = moment(expirationDate, 'YYYY-MM-DD').isValid();

        setFilesValid(filesValid);
        setExpirationDateValid(expirationDateValid);
        setDirty(true);

        if (filesValid && expirationDateValid) {
            props.onSubmit(files[0], expirationDate);
        }
    };

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Upload Scrip File</Modal.Header>
            <Modal.Body>
                {!filesValid || !expirationDateValid && (
                    <Alert bsStyle='danger'>The items are in red are required to submit...</Alert>
                )}

                <Alert bsStyle='info' bsSize='sm' style={{ marginBottom: 20, textAlign: 'center' }}>
                    For donor <strong>{props.fullName}</strong>, please upload the scrip file and <br />specify the script expiration date...
                </Alert>

                <Form horizontal>
                    <FormGroup validationState={dirty && filesValid == false ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Upload PDF File:</Col>
                        <Col xs={12} lg={8}>
                            <FileUpload
                                label={'Click to select the PDF...'}
                                files={files}
                                singleUploadOnly={true}
                                onFileDropped={handleFileDropped}
                                onRemoveFile={handleRemoveFile} />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={dirty && expirationDateValid == false ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Scrip Expiration Date:</Col>
                        <Col xs={12} lg={8}>
                            <FormControl
                                className='input-group'
                                type='date'
                                id='date'
                                name='expirationDate'
                                value={expirationDate}
                                onChange={handleExpirationDateChange}
                            />
                        </Col>
                    </FormGroup>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSubmit}>Upload and Notify Donor</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default UploadScrip;